export var headerBackground = "backgroundLight";
export var headerBackgroundOnBiggerScreen = "background";
export var headerGap = 1;
export var headerVerticalPaddingSpace = 1;
export var headerLinkHeightSpace = 4;